import {
  ADD_TO_NAV_HISTORY,
  GO_BACK_IN_HISTORY,
  GO_FORWARD_IN_HISTORY,
  NAVIGATE_TO_BREADCRUMB,
} from '../actions/navigationHistory'

const initialState = {
  history: [{ route: '/', title: 'Dashboard', timestamp: Date.now() }],
  currentIndex: 0,
}

export const navigationHistory = (state = initialState, action) => {
  switch (action.type) {
    case ADD_TO_NAV_HISTORY:
      const { route, title, timestamp } = action.payload

      // If navigating to dashboard, RESET everything - start fresh
      if (route === '/') {
        return {
          ...state,
          history: [{ route: '/', title: 'Dashboard', timestamp }],
          currentIndex: 0,
        }
      }

      // Remove forward history (everything after current index)
      const trimmedHistory = state.history.slice(0, state.currentIndex + 1)

      // Don't add duplicate consecutive entries
      const lastEntry = trimmedHistory[trimmedHistory.length - 1]
      if (lastEntry && lastEntry.route === route) {
        return state
      }

      // Ensure Dashboard is always first, then add new page
      let newHistory
      if (trimmedHistory[0].route === '/') {
        // Dashboard is already first, just append
        newHistory = [...trimmedHistory, { route, title, timestamp }]
      } else {
        // This shouldn't happen, but ensure dashboard is first
        newHistory = [
          {
            route: '/',
            title: 'Dashboard',
            timestamp: state.history[0].timestamp,
          },
          { route, title, timestamp },
        ]
      }

      return {
        ...state,
        history: newHistory,
        currentIndex: newHistory.length - 1,
      }

    case GO_BACK_IN_HISTORY:
      if (state.currentIndex > 0) {
        return {
          ...state,
          currentIndex: state.currentIndex - 1,
        }
      }
      return state

    case GO_FORWARD_IN_HISTORY:
      if (state.currentIndex < state.history.length - 1) {
        return {
          ...state,
          currentIndex: state.currentIndex + 1,
        }
      }
      return state

    case NAVIGATE_TO_BREADCRUMB:
      const targetIndex = action.payload
      if (targetIndex >= 0 && targetIndex < state.history.length) {
        // If clicking on Dashboard breadcrumb, reset history
        if (targetIndex === 0) {
          return {
            ...state,
            history: [state.history[0]],
            currentIndex: 0,
          }
        }
        return {
          ...state,
          currentIndex: targetIndex,
        }
      }
      return state

    default:
      return state
  }
}
